export default {
  methods: {
    isNullOrWhitespace: function (input) {
      if (typeof input === 'undefined' || input == null) {
        return true;
      }
      return !/\S/.test(input); // Does it fail to find a non-whitespace character?
    }
  }
}
